import { useQuery } from '@apollo/client';
import { isEmpty, isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';

export function useWorkflowEntitiesByIds({
  workflowTemplateId,
  workflowEntityIds,
}: {
  workflowTemplateId?: string | null;
  workflowEntityIds?: string[];
}): {
  workflowTemplate?: API.WorkflowTemplateFragment;
  workflowEntities: API.WorkflowEntity[];
  /** Related entity refs returned alongside the queried entities (e.g. their related cards). */
  workflowEntityRefs: API.WorkflowEntity[];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    API.GetWorkflowEntitiesQuery,
    API.GetWorkflowEntitiesQueryVariables
  >(Queries.workflow.getWorkflowEntities, {
    variables: {
      input: {
        ids: workflowEntityIds ?? [],
        workflowTemplateId: workflowTemplateId ?? '',
      },
    },
    skip: isNil(workflowTemplateId) || isEmpty(workflowEntityIds),
  });
  const workflowEntities = data?.workflowEntities?.entities?.filter(e => !isNil(e)) ?? [];
  const workflowEntityRefs = data?.workflowEntities?.refs?.workflowEntityRefs?.filter(notNil) ?? [];
  const workflowTemplate = data?.workflowEntities?.refs?.workflowTemplateRefs?.find(
    wft => wft.id === workflowTemplateId,
  );

  return { workflowTemplate, workflowEntities, workflowEntityRefs, loading, error };
}
